import { RouteConfig } from "vue-router";
import { REmployerVisaCasesBrowse } from "@/pages/Layout/views/Employer/views/VisaCases/Browse/REmployerVisaCasesBrowse";
import { REmployerVisaCasesTemplate } from "@/pages/Layout/views/Employer/views/VisaCases/Template/REmployerVisaCasesTemplate";

export const REmployerVisaCases: RouteConfig = {
  path: "visa-cases",
  name: "VisaCases",
  component: () =>
    import(
      /* webpackChunkName: "employer-visa-cases" */
      "./VEmployerVisaCases.vue"
    ),
  meta: {
    title: "Visa Cases",
    newIcon: "file-certificate",
    version: 2,
    childLabel: "Job templates",
    aliasRoutes: ["cases", "employer/invite"],
  },
  children: [REmployerVisaCasesBrowse, REmployerVisaCasesTemplate],
};
